// src/features/mech/sheetmetal/questions/AnnualVolumeQuestion.jsx
import React from "react";
import { Box } from "@mui/material";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";
import PerlChip from "../../../../shared/components/PerlChip";

/**
 * AnnualVolumeQuestion Component
 *
 * Custom question for Mechanical Sheet Metal: captures the annual volume selection
 * Uses chip-based selection for volume ranges
 *
 * @param {string} value - Current annual volume value
 * @param {function} onChange - Callback when the volume selection changes (receives string value)
 * @param {string} [error] - Optional error message
 * @param {string} [success] - Optional success/help message
 * @param {function} [onNextStep] - Optional callback to proceed to next step (not used for chip selection)
 * @param {number} [currentStep] - Current step index
 */
export default function AnnualVolumeQuestion({ value, onChange, error, success, onNextStep, currentStep }) {
  const options = [
    { value: "Low Volume", label: "Low Volume" },
    { value: "Medium Volume", label: "Medium Volume" },
    { value: "High Volume", label: "High Volume" },
  ];

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      <PerlLabelMedium sx={{ mb: 1, display: "block" }}>
        Select Annual Volume:
      </PerlLabelMedium>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {options.map((option) => (
          <PerlChip
            key={option.value}
            label={option.label}
            selected={value === option.value}
            onClick={() => onChange(option.value)}
          />
        ))}
      </Box>
      {error && (
        <PerlLabelMedium sx={{ mt: 1, color: "error.main" }}>{error}</PerlLabelMedium>
      )}
      {success && (
        <PerlLabelMedium sx={{ mt: 1, color: "success.main" }}>{success}</PerlLabelMedium>
      )}
    </Box>
  );
}

